/**
 * Created by razial on 26.10.2021
 */

const Pocket = function (locationId) {
    const locationMeta = cleverapps.meta.getLocationMeta(locationId);

    this.locationId = locationMeta.locationId;
    this.slotId = locationMeta.slotId;

    this.bubbles = [];

    this.onAddBubble = function () {};

    this.load();
};

Pocket.prototype.save = function () {
    cleverapps.dataLoader.save(DataLoader.TYPES.POCKET + this.slotId, {
        bubbles: this.bubbles.map((bubble) => ({
            code: bubble.code,
            stage: Pocket.restoreDeletedStage(bubble.code, bubble.stage),
            x: bubble.x,
            y: bubble.y
        }))
    });

    connector.synchronizer.addSendTask(`pocket${this.slotId}`);
};

Pocket.prototype.load = function () {
    let bubbles = [];
    const data = cleverapps.dataLoader.load(DataLoader.TYPES.POCKET + this.slotId);

    // migrate
    if (data && data.units) {
        const units = Pocket.expandUnits(data.units);
        units.forEach((unit) => {
            bubbles.push(unit);
        });

        const positions = cleverapps.dataLoader.load(DataLoader.TYPES.BUBBLES + this.slotId);
        if (positions && positions.bubbles) {
            positions.bubbles.forEach((position) => {
                for (let i = 0; i < bubbles.length; ++i) {
                    const bubble = bubbles[i];
                    if (bubble.code === position.code && bubble.stage === position.stage && bubble.x === undefined && bubble.y === undefined) {
                        bubble.x = position.x;
                        bubble.y = position.y;
                        break;
                    }
                }
            });
        }
    }

    if (data && data.bubbles) {
        bubbles = data.bubbles;
    }

    this.bubbles = bubbles.map((bubble) => new PocketBubble({
        code: bubble.code,
        stage: Pocket.removeDeletedStage(bubble.code, bubble.stage),
        x: bubble.x,
        y: bubble.y
    }));
};

Pocket.prototype.validate = function (location) {
    const validBubbles = [];
    let invalidBubbles = [];

    this.bubbles.forEach((bubble) => {
        if (location.families[bubble.code]) {
            validBubbles.push(bubble);
        } else if (Families[bubble.code]) {
            invalidBubbles.push(bubble);
        }
    });

    if (this.bubbles.length !== validBubbles.length) {
        this.bubbles = validBubbles;
        this.save();

        if (invalidBubbles.length) {
            invalidBubbles = invalidBubbles.map((bubble) => bubble.code).join(", ");

            cleverapps.throwAsync(`units from other expedition in pocket slotId:${this.slotId} location:${location.locationId} units:${invalidBubbles}`);
        }
    }
};

Pocket.prototype.addUnits = function (units, parentUnit) {
    let position = {};

    if (parentUnit) {
        position = Map2d.currentMap.getMapView().alignInGrid(parentUnit.x, parentUnit.y);
    }

    const unitsArray = cleverapps.toArray(units).filter((unit) => !Unit.DISABLED_CODES[unit.code] && unit.code !== "unknown");

    const bubbles = [];
    unitsArray.forEach((unit) => {
        for (let index = 0; index < (unit.amount || 1); index++) {
            if (unit.code === "landmark") {
                let msg = `PocketLandmark ${unit.stage}`;
                Map2d.currentMap.listAvailableUnits({ type: "landmark" }).forEach((unit) => {
                    msg += ` ${unit.stage}_${unit.x}x${unit.y}`;
                });
                msg += ` ${new Error().stack}`;
                cleverapps.throwAsync(msg);
                continue;
            }

            bubbles.push(new PocketBubble({
                code: unit.code,
                stage: unit.stage,
                x: position.x,
                y: position.y
            }));
        }
    });

    if (!bubbles.length) {
        return;
    }

    this.bubbles = this.bubbles.concat(bubbles);

    this.save();

    bubbles.forEach(function (bubble) {
        this.onAddBubble(bubble);
    }, this);
};

Pocket.prototype.removeBubble = function (bubble) {
    const index = this.bubbles.indexOf(bubble);
    if (index > -1) {
        this.bubbles.splice(index, 1);
        this.save();
    }
};

Pocket.prototype.listUnits = function () {
    return this.bubbles.map((bubble) => ({
        code: bubble.code,
        stage: bubble.stage
    }));
};

Pocket.prototype.isEmpty = function () {
    return !this.bubbles.length;
};

Pocket.prototype.showHint = function () {
    if (this.bubbles.length <= Pocket.AMOUNT_TO_SHOW_HINT || this.hintShown) {
        return;
    }

    const bubble = this.bubbles[this.bubbles.length - 1];
    const bubbleView = bubble.onGetView();
    if (!bubbleView) {
        return;
    }

    cleverapps.focusManager.display({
        focus: "ShowPocketHint",
        keepControls: true,
        action: function (f) {
            this.hintShown = true;

            Map2dLocation.currentLocation.counter.setTimeout(() => {}, Pocket.HINT_DURATION);

            Map2d.currentMap.focusOnTarget(bubbleView, {
                allowScrollWithFocus: true,
                duration: 0.8,
                callback: function () {
                    cleverapps.centerHint.createTextHint(Messages.get("PocketBubble.click"));

                    bubble.showFinger();

                    f();
                }
            });
        }.bind(this)
    });
};

Pocket.AMOUNT_TO_SHOW_HINT = 60;
Pocket.HINT_DURATION = 3200;

Pocket.MAX_DATA_LENGTH = 200;
Pocket.DELIMITERS = ":,;.~_{}[]";

Pocket.reset = function (slotId) {
    cleverapps.dataLoader.save(DataLoader.TYPES.POCKET + slotId, {});
    connector.synchronizer.addSendTask(`pocket${slotId}`);
};

UniversalSlot.HANDLER_FACTORIES.pocket = (slot) => ({
    reset: () => Pocket.reset(slot.slotId)
});

Pocket.compactUnits = function (units) {
    units = units.slice();
    if (typeof Map2dLocation !== "undefined") {
        units.sort(Map2d.LOAD_UNITS_COMPARATOR());
    }

    let data = "";
    let truncated = [];

    let code;
    units.forEach((unit) => {
        if (code !== unit.code) {
            if (data.length + 3 > Pocket.MAX_DATA_LENGTH) {
                truncated.push(unit);
                return;
            }

            code = unit.code;

            const id = Families.getIdByCompactCode(code);
            data += Pocket.DELIMITERS[Math.floor(id / 80)] + Base80.compactNumber(id % 80, 1);
        }

        if (data.length + 1 > Pocket.MAX_DATA_LENGTH) {
            truncated.push(unit);
            return;
        }

        data += Base80.compactNumber(unit.stage, 1);
    });

    if (truncated.length && typeof exports === "undefined") {
        truncated = truncated.map((unit) => `${unit.code}_${unit.stage}`);
        cleverapps.throwAsync({ group: "PocketStringTooLong", message: `pocket string is too long: truncated units ${truncated.join(" ")}` });
    }

    return data;
};

Pocket.expandUnits = function (data) {
    const units = []; 
    let i = 0, code, unknown = "";
    while (i < data.length) {
        const delimiter = Pocket.DELIMITERS.indexOf(data[i]);
        if (delimiter > -1) {
            code = Families.getCompactCodeById(delimiter * 80 + Base80.expandNumber(data[i + 1]));
            if (!code) {
                unknown += data[i] + data[i + 1];
            }

            i += 2;
            continue;
        }

        if (!code) {
            unknown += data[i];
            i += 1;
            continue;
        }

        units.push({ code, stage: Base80.expandNumber(data[i]) });
        i += 1;
    }

    if (unknown.length) {
        cleverapps.throwAsync(`expand unknown unit in pocket: ${unknown}`);
    }
    return units;
};

if (typeof exports === "undefined") {
    SyncAdapters.registerBySlots("pocket", {
        getInfo: (slotId) => {
            const data = cleverapps.dataLoader.load(DataLoader.TYPES.POCKET + slotId);
            return {
                units: data && data.bubbles && Pocket.compactUnits(data.bubbles) || ""
            };
        },

        updateInfo: (slotId, serverData) => {
            cleverapps.dataLoader.save(DataLoader.TYPES.POCKET + slotId, {
                bubbles: Pocket.expandUnits(serverData && serverData.units || "")
            });
        }
    });
}

Pocket.removeDeletedStage = function (code, stage) {
    const deleted = Families.DELETED_STAGES && Families.DELETED_STAGES[code];
    if (!deleted || !deleted.length) {
        return stage;
    }
    const original = stage;
    for (let i = 0; i < deleted.length && deleted[i] <= original; i++) {
        stage -= 1;
    }
    return stage;
};

Pocket.restoreDeletedStage = function (code, stage) {
    const deleted = Families.DELETED_STAGES && Families.DELETED_STAGES[code];
    if (!deleted || !deleted.length) {
        return stage;
    }
    for (let i = 0; i < deleted.length && deleted[i] <= stage; i++) {
        stage += 1;
    }
    return stage;
};

Pocket.initialize = function () {
    const intersect = Pocket.DELIMITERS.split("").filter((ch) => Base80.STR.includes(ch)).join("");

    if (intersect) {
        throw (`Pocket.delimiters intersects with Base80.STR - ${intersect}`);
    }

    const ids = {};

    Families.codes.forEach((code) => {
        const id = Families[code].id;

        let error = "";
        if (typeof id !== "number") {
            error = `No id specified for family: ${code}`;
        } else if (id >= Base80.STR.length * Pocket.DELIMITERS.length) {
            error = `Family id ${id} is big`;
        } else if (ids[id] && ids[id] !== code) {
            error = `Not unique family id ${id}`;
        }

        if (error) {
            throw error;
        }
        ids[id] = code;
    });
};

if (typeof cc === "undefined") {
    module.exports = Pocket;
}
